
import { put, select, takeLatest } from "redux-saga/effects"
import { loginWatcher, handleError, 
} from "../actions/loginactioncreators";
import actionTypes from "../actions/actiontypes";
import getChallenge from "../helpers/getChallenge";
import getPassword from "../helpers/getPassword";

export function* sendMfaSkip() {

    try {
        const challenge = yield select(getChallenge);
        const password = yield select(getPassword);

        const payload = {
            flowStage: "CHALLENGE_MFA_SETUP",
            challengeResponse: {
                step: "MFA_SETUP_SKIP",
                session: challenge.session,
                challengeParameters: {
                    USERNAME: challenge.challengeParameters.USER_ID_FOR_SRP,
                    PASSWORD: password,
                },
            }
        };
        yield put(loginWatcher(payload));
    } catch (error) {
        yield put(handleError(error));
    }
}

export function* watchMfaSkipAsync() {
    yield takeLatest(actionTypes.MFA_SKIP, sendMfaSkip);
}